// extracted by mini-css-extract-plugin
export var inputContainer = "_on-0";